var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('img',{staticClass:"notFound",attrs:{"src":require("../../assets/image/404Bird.png"),"alt":"404 notFound"}}),_c('img',{staticClass:"dizzyStar",attrs:{"src":require("../../assets/image/dizzy_star.gif"),"alt":"dizzy star"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }